module.exports = "/_next/static/images/Brian_Bertrand-9b9ad8e9176ef64ccc70c6d284f0b6f9.webp";